import { useStorage } from '@vueuse/core'

export default defineNuxtRouteMiddleware(async () => {
  if (process.server)
    return

  const isLoggedIn = useStorage('is_logged_in', false)
  const { firebaseUser } = useFirebaseAuth()

  await until(firebaseUser).toBeTruthy({ timeout: 1000 })

  if (firebaseUser.value) {
    isLoggedIn.value = true
    return navigateTo('/')
  }
})
